import Vue from 'vue'
import Router from 'vue-router'
import DashboardLayout from '@/layout/DashboardLayout'
import AuthLayout from '@/layout/AuthLayout'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      redirect: 'dashboard',
      component: DashboardLayout,
      children: [
        {
          path: '/dashboard',
          name: 'dashboard',
          // route level code-splitting
          // this generates a separate chunk (about.[hash].js) for this route
          // which is lazy-loaded when the route is visited.
          component: () => import(/* webpackChunkName: "demo" */ './views/Dashboard.vue')
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import(/* webpackChunkName: "demo" */ './views/UserProfile.vue')
        },
        {
          path: '/requirements-policy',
          name: 'Requirements Policy',
          component: () => import(/* webpackChunkName: "demo" */ './views/Others/PortalGuidelines.vue')
        },
        {
          path: '/change-password',
          name: 'Change Password',
          component: () => import(/* webpackChunkName: "demo" */ './views/Profile/ChangePassword.vue')
        },
        {
          path: '/applications',
          name: 'My Applications',
          component: () => import(/* webpackChunkName: "demo" */ './views/Applications/Applications.vue')
        },
        {
          path: '/letters',
          name: 'My Letters',
          component: () => import(/* webpackChunkName: "demo" */ './views/Letters/Letters.vue')
        },
        {
          path: '/verification-visit',
          name: 'Verification Visit',
          component: () => import(/* webpackChunkName: "demo" */ './views/VerificationVisit/VerificationVisit.vue')
        },
        {
          path: '/application-details/:id',
          name: 'Application Details',
          component: () => import(/* webpackChunkName: "demo" */ './views/Applications/ApplicationDetails.vue')
        },
        {
          path: '/pending-application/:id',
          name: 'Pending Application',
          component: () => import(/* webpackChunkName: "demo" */ './views/Applications/NewApplication/ApplicationForm.vue')
        },
        {
          path: '/new-accreditation',
          name: 'New Accreditation Application',
          component: () => import(/* webpackChunkName: "demo" */ './views/Applications/Reaccreditation/Reaccreditation.vue')
        },
        {
          path: '/re-accreditation',
          name: 'Re-accreditation Application',
          component: () => import(/* webpackChunkName: "demo" */ './views/Applications/Reaccreditation/Reaccreditation.vue')
        },
        {
          path: '/payments',
          name: 'My Payments',
          component: () => import(/* webpackChunkName: "demo" */ './views/Payments/Payments.vue')
        },
        {
          path: '/notifications',
          name: 'Notifications',
          component: () => import(/* webpackChunkName: "demo" */ './views/Notifications/Notifications.vue')
        },
        {
          path: '/notifications/:slug',
          name: 'Notification Details',
          component: () => import(/* webpackChunkName: "demo" */ './views/Notifications/SingleNotification.vue')
        },
        {
          path: '/logout',
          name: 'logout',
          component: () => import(/* webpackChunkName: "demo" */ './views/Logout.vue')
        }
      ],
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verification-payment',
      name: 'Application Page',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verification/Verification.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verification-generate',
      name: 'Application Payment Page',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verification/VerificationGenerate.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verification-callback',
      name: 'Application Payment Callback Page',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verification/VerificationCallback.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/verification/check-payment',
      name: 'Application Payment Check Page',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verification/VerificationRrr.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/application-form',
      name: 'Accreditation Application Form',
      component: () => import(/* webpackChunkName: "demo" */ './views/Verification/Application/ApplicationForm.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      redirect: 'login',
      component: AuthLayout,
      children: [
        {
          path: '/login',
          name: 'Hospital Login',
          component: () => import(/* webpackChunkName: "demo" */ './views/Auth/Login/Login.vue')
        },
        {
          path: '/register',
          name: 'New Hospital Account',
          component: () => import(/* webpackChunkName: "demo" */ './views/Auth/Register/Register.vue')
        },
        {
          path: '/password-reset',
          name: 'password reset',
          component: () => import(/* webpackChunkName: "demo" */ './views/PasswordReset.vue')
        },
        {
          path: '/update-password',
          name: 'Update Password',
          component: () => import(/* webpackChunkName: "demo" */ './views/UpdatePassword.vue')
        }
      ],
      meta: {
        requiresVisitor: true
      }
    },
    {
      path: '/requirements',
      name: 'Requirements',
      component: () => import(/* webpackChunkName: "demo" */ './views/Requirements/Requirements.vue'),
      meta: {
        requiresVisitor: true
      }
    },
    {
      path: '/mfa/setup',
      name: 'MFA Setup',
      component: () => import(/* webpackChunkName: "demo" */ './views/Auth/Mfa/MfaSetup.vue'),
      meta: {
        requiresMfa: true
      }
    },
    {
      path: '/mfa/challenge',
      name: 'MFA Challenge',
      component: () => import(/* webpackChunkName: "demo" */ './views/Auth/Mfa/MfaChallenge.vue'),
      meta: {
        requiresMfa: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let saved = localStorage.getItem('time_out');// set access token
    let lockTime = localStorage.getItem('lock_time');// get lock time
    if(! lockTime) {// initiate profile lock function
      let hours = 3;
      localStorage.setItem('lock_time', new Date().getTime() + (hours * 60 * 60 * 1000));// set lock time
    }
    if (saved && (saved < new Date().getTime())) {//session time out
        localStorage.clear();
        window.location.reload();
    }
    if (! store.getters.isLoggedIn) {
      next({
        path: '/login'
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresVisitor)) {
    if (store.getters.isLoggedIn) {
      next({
        path: '/'
      })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresMfa)) {
    if (store.getters.isLoggedIn) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  } else {
    next()
  }
});

export default router;
